export enum BillingStatusAPiUrl {
  billing = 'Billing',
  OrganizationBillingStatus = 'OrganizationBillingStatus',
}
